module.exports = __webpack_public_path__ + "img/convert_image_vertical_85.d8e5f59e.svg";